export { EDITOR_STATE, EDITOR_TYPE, BaseEditor } from "./baseEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/baseEditor/index.mjs
// module id = 207
// module chunks = 1